import { memo } from "react";
import { Link } from "react-router-dom";

const Button = (props) => {
  const {
    onClick = () => {},
    text = "",
    className = "",
    style = {},
    to = "",
    nosite = false,
    disabled = false,
  } = props;

  let class_name = `${!nosite ? "site-btn" : ""} ${className}`;

  if (to && to !== "") {
    return (
      <Link className={class_name} to={to}>
        {text}
      </Link>
    );
  }

  return (
    <button
      disabled={disabled}
      style={style}
      className={class_name}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default memo(Button);
